export interface Category {
  slug: string;
  name: string;
  subtitle?: string;
  description: string;
  image: string;
  subcategories: string[];
  active: boolean;
}

export const categories: Category[] = [
  {
    slug: "excavators",
    name: "Excavators",
    subtitle: "Dig Deeper and Work Smarter",
    description:
      "Kasai provides robust Engirise excavators designed to conquer Africa's toughest sites. Featuring reinforced undercarriages, powerful hydraulics, and climate-controlled cabins – perfect for all-day deep excavation.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777012086112-ExcavatorEN220-01.webp",
    subcategories: ["Diesel Crawler Excavator"],
    active: true,
  },
  {
    slug: "loaders",
    name: "Loaders",
    subtitle: "Move Mountains of Material",
    description:
      "Our range of premium Engirise loaders handle the most demanding material handling tasks. Explore versatile variants across wheel loaders, backhoe loaders, and skid steer loaders – built for stable performance on uneven terrain.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777012187572-Backhoe_loaderBL124SD-01.webp",
    subcategories: ["WHEEL LOADER", "WHEELED SKID STEER LOADER", "BACKHOE LOADER"],
    active: true,
  },
  {
    slug: "forklifts",
    name: "Forklifts",
    subtitle: "Lift up Logistics with Higher Efficiency",
    description:
      "Kasai's Engirise forklifts are engineered for relentless performance in Africa's ports, warehouses, and factories. Available in standard and telescopic variants - delivering higher, longer lifting in tighter spaces.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015024440-Forklift_FL35-01.webp",
    subcategories: ["DIESEL FORKLIFT", "TELESCOPIC FORKLIFT"],
    active: true,
  },
  {
    slug: "road-machinery",
    name: "Road Machinery",
    subtitle: "Build Infrastructure that Endures",
    description:
      "Our precision Engirise road equipment paves the way for African development. Build roads that withstand heavy traffic and extreme weather with motor graders and road rollers – engineered for accuracy and high compaction.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015095107-Road_RollerEC180.webp",
    subcategories: ["SINGLE DRUM ROAD ROLLER", "MOTOR GRADER"],
    active: true,
  },
  {
    slug: "mewps",
    name: "MEWPs",
    subtitle: "Elevate your Team for Safer Work",
    description:
      "Kasai's range of Engirise mobile elevating work platforms enable you to reach new heights. Explore safe, stable scissor and boom lifts - designed for complex work access in challenging and remote terrain.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015366140-Telescopic_ForkliftEFT60-01.webp",
    subcategories: ["SCISSOR LIFT", "DIESEL ARTICULATED BOOM LIFT", "DIESEL TELESCOPIC BOOM LIFT"],
    active: true,
  },
  {
    slug: "agriculture",
    name: "Agriculture Machinery",
    subtitle: "Powering Every Season",
    description: "High-performance agricultural machinery for African farming.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015366140-Telescopic_ForkliftEFT60-01.webp",
    subcategories: ["TRACTOR"],
    active: false,
  },
  {
    slug: "concrete",
    name: "Concrete Machinery",
    subtitle: "Consistency You Can Build On",
    description: "Professional concrete mixing and pumping solutions.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015366140-Telescopic_ForkliftEFT60-01.webp",
    subcategories: ["SELF-LOADING CONCRETE MIXER", "CONCRETE PUMP", "CONCRETE LEVELING MACHINE"],
    active: false,
  },
  {
    slug: "cranes",
    name: "Cranes",
    subtitle: "Heavy Loads, Total Control",
    description: "Heavy lifting solutions for infrastructure and industry.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015366140-Telescopic_ForkliftEFT60-01.webp",
    subcategories: ["ALL-TERRAIN CRANE", "CRAWLER CRANE", "ROUGH TERRAIN CRANE", "TRUCK CRANE"],
    active: false,
  },
  {
    slug: "warehouse",
    name: "Warehouse Equipment",
    subtitle: "Heavy Loads, Total Control",
    description: "Efficient warehouse management equipment.",
    image:
      "https://biwahyd29hzswfov.public.blob.vercel-storage.com/categories/1777015366140-Telescopic_ForkliftEFT60-01.webp",
    subcategories: [],
    active: false,
  },
];
